import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  Grid,
  Stack,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
  IconButton,
  Autocomplete,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from "@mui/material";
import { Inchargecomplete, PartySingleSelect, Productautocomplete } from "../../../ui-components/global/Autocomplete";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { DesignationGet, EmployeeAddController, EmployeeMapController, EmployeeProjectsGet, ProjectSplitupHrsList, TotalHrsOccupiedHrsGet } from "../../../store/reducers/Formapireducer";
import toast from "react-hot-toast";
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../Theme";
import { dataGridHeaderFooterHeight, dataGridRowHeight } from "../../../ui-components/global/utils";
import PersonRemoveAlt1Icon from "@mui/icons-material/PersonRemoveAlt1";


const TEAL = "#21B5B5";
const TEAL_DARK = "#3da58a";
const TEAL_LIGHT = "#e0f2f1";
const TEAL_BORDER = "#b2dfdb";

const muiCDN = `
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');
`;

const ROLES = [
  "Site Engineer", "Foreman", "Safety Officer",
  "Structural Engineer", "Electrician", "Plumber", "Mason", "Crane Operator"
];
const INCHARGES = [
  "Rajesh Pandey (PM)", "Suresh Babu (PM)",
  "Nandini Rajan (PM)", "Arjun Mehta (SE)", "Karthik Balaji (SE)"
];
const TASK_STATUS = {
  I: { color: "#1565c0", bg: "#e3f2fd", label: "In Progress" },
  C: { color: "#2e7d32", bg: "#e8f5e9", label: "Completed" },
  AS: { color: "#e65100", bg: "#fff8e1", label: "Pending" },
  SH: { color: "#e65100", bg: "#fff8e1", label: "Scheduled" },
};
const PROJ_STATUS = {
  Active: { color: "#004d40", bg: "#e0f2f1", label: "Active" },
  NotActive: { color: "#d62404", bg: "#e0f2f1", label: "Not Active" },
  Planning: { color: "#0d47a1", bg: "#e3f2fd", label: "Planning" },
  Completing: { color: "#e65100", bg: "#fff8e1", label: "Completing" },
  Completed: { color: "#4a148c", bg: "#f3e5f5", label: "Completed" },
};

const ALL_EMP = [
  {
    id: 1, name: "Arjun Mehta", role: "Site Engineer", total: 160, occupied: 40, projects: [
      {
        name: "Skyline Residency", dur: "8 mo", hrs: 20, status: "active", incharge: "Rajesh Pandey (PM)", tasks: [
          { name: "Foundation layout inspection", from: "01-01-2026", to: "15-01-2026", hrs: 6, status: "completed" },
          { name: "Column marking & alignment", from: "16-01-2026", to: "31-01-2026", hrs: 5, status: "completed" },
          { name: "Slab shuttering supervision", from: "01-02-2026", to: "20-02-2026", hrs: 5, status: "inprogress" },
          { name: "Progress report — block A", from: "21-02-2026", to: "28-02-2026", hrs: 4, status: "pending" },
        ]
      },
      {
        name: "Old Port Bridge", dur: "4 mo", hrs: 20, status: "planning", incharge: "Suresh Babu (PM)", tasks: [
          { name: "Site survey & soil report", from: "10-03-2026", to: "20-03-2026", hrs: 8, status: "inprogress" },
          { name: "Pile foundation design check", from: "21-03-2026", to: "10-04-2026", hrs: 12, status: "pending" },
        ]
      },
    ]
  },
  {
    id: 2, name: "Priya Sharma", role: "Site Engineer", total: 160, occupied: 130, projects: [
      {
        name: "Expressway Ext.", dur: "12 mo", hrs: 50, status: "active", incharge: "Nandini Rajan (PM)", tasks: [
          { name: "Road base compaction check", from: "05-01-2026", to: "25-01-2026", hrs: 15, status: "completed" },
          { name: "Drainage culvert supervision", from: "26-01-2026", to: "15-02-2026", hrs: 20, status: "inprogress" },
          { name: "Bitumen layer QC", from: "16-02-2026", to: "10-03-2026", hrs: 15, status: "pending" },
        ]
      },
      {
        name: "DLF Tower", dur: "6 mo", hrs: 50, status: "completing", incharge: "Rajesh Pandey (PM)", tasks: [
          { name: "Final MEP coordination", from: "01-02-2026", to: "20-02-2026", hrs: 20, status: "completed" },
          { name: "Finishing works inspection", from: "21-02-2026", to: "10-03-2026", hrs: 18, status: "inprogress" },
          { name: "Handover punch list", from: "11-03-2026", to: "25-03-2026", hrs: 12, status: "pending" },
        ]
      },
      {
        name: "Harbor View", dur: "5 mo", hrs: 30, status: "active", incharge: "Suresh Babu (PM)", tasks: [
          { name: "Waterproofing supervision", from: "01-03-2026", to: "20-03-2026", hrs: 15, status: "inprogress" },
          { name: "External cladding check", from: "21-03-2026", to: "15-04-2026", hrs: 15, status: "pending" },
        ]
      },
    ]
  },
  {
    id: 3, name: "Ravi Kumar", role: "Foreman", total: 160, occupied: 20, projects: [
      {
        name: "NH-48 Overpass", dur: "3 mo", hrs: 20, status: "completing", incharge: "Karthik Balaji (SE)", tasks: [
          { name: "Railing installation", from: "01-03-2026", to: "15-03-2026", hrs: 8, status: "completed" },
          { name: "Expansion joint fitting", from: "16-03-2026", to: "25-03-2026", hrs: 7, status: "inprogress" },
          { name: "Final safety walkthrough", from: "26-03-2026", to: "31-03-2026", hrs: 5, status: "pending" },
        ]
      },
    ]
  },
  {
    id: 4, name: "Sunita Nair", role: "Foreman", total: 160, occupied: 80, projects: [
      {
        name: "Metro Depot", dur: "10 mo", hrs: 40, status: "active", incharge: "Rajesh Pandey (PM)", tasks: [
          { name: "Track laying coordination", from: "01-01-2026", to: "31-01-2026", hrs: 20, status: "completed" },
          { name: "Platform slab formwork", from: "01-02-2026", to: "28-02-2026", hrs: 20, status: "inprogress" },
        ]
      },
      {
        name: "SIPCOT Block C", dur: "6 mo", hrs: 40, status: "planning", incharge: "Nandini Rajan (PM)", tasks: [
          { name: "Site clearance & mobilisation", from: "01-04-2026", to: "20-04-2026", hrs: 20, status: "pending" },
          { name: "Temporary access road layout", from: "21-04-2026", to: "10-05-2026", hrs: 20, status: "pending" },
        ]
      },
    ]
  },
  {
    id: 5, name: "Vijay Anand", role: "Safety Officer", total: 160, occupied: 10, projects: [
      {
        name: "OMR Phase 3", dur: "2 mo", hrs: 10, status: "completing", incharge: "Suresh Babu (PM)", tasks: [
          { name: "PPE compliance audit", from: "01-03-2026", to: "10-03-2026", hrs: 4, status: "completed" },
          { name: "Final safety sign-off", from: "11-03-2026", to: "25-03-2026", hrs: 6, status: "inprogress" },
        ]
      },
    ]
  },
  {
    id: 6, name: "Deepa Rao", role: "Safety Officer", total: 160, occupied: 100, projects: [
      {
        name: "Tidel Park Ext.", dur: "8 mo", hrs: 100, status: "active", incharge: "Rajesh Pandey (PM)", tasks: [
          { name: "Fire exit compliance check", from: "01-01-2026", to: "20-01-2026", hrs: 25, status: "completed" },
          { name: "Scaffolding safety inspection", from: "21-01-2026", to: "10-02-2026", hrs: 30, status: "inprogress" },
          { name: "Monthly toolbox talks", from: "01-03-2026", to: "31-05-2026", hrs: 25, status: "pending" },
        ]
      },
    ]
  },
  {
    id: 7, name: "Karthik Balaji", role: "Structural Engineer", total: 160, occupied: 55, projects: [
      {
        name: "Anna Nagar Complex", dur: "7 mo", hrs: 55, status: "active", incharge: "Nandini Rajan (PM)", tasks: [
          { name: "Structural drawing approval", from: "01-01-2026", to: "20-01-2026", hrs: 15, status: "completed" },
          { name: "Beam & column design review", from: "21-01-2026", to: "15-02-2026", hrs: 20, status: "inprogress" },
          { name: "Load calculation verification", from: "16-02-2026", to: "10-03-2026", hrs: 20, status: "pending" },
        ]
      },
    ]
  },
  {
    id: 8, name: "Meena Pillai", role: "Structural Engineer", total: 160, occupied: 150, projects: [
      {
        name: "T-Nagar Flyover", dur: "9 mo", hrs: 60, status: "active", incharge: "Suresh Babu (PM)", tasks: [
          { name: "Girder design & review", from: "01-01-2026", to: "31-01-2026", hrs: 30, status: "completed" },
          { name: "Pre-cast slab analysis", from: "01-02-2026", to: "28-02-2026", hrs: 30, status: "inprogress" },
        ]
      },
      {
        name: "Vadapalani Hub", dur: "4 mo", hrs: 50, status: "completing", incharge: "Rajesh Pandey (PM)", tasks: [
          { name: "Structural audit — block B", from: "01-02-2026", to: "20-02-2026", hrs: 25, status: "completed" },
          { name: "Final structural clearance", from: "21-02-2026", to: "10-03-2026", hrs: 25, status: "inprogress" },
        ]
      },
    ]
  },
  {
    id: 9, name: "Suresh Venkat", role: "Electrician", total: 160, occupied: 30, projects: [
      {
        name: "IT Corridor Block", dur: "3 mo", hrs: 30, status: "completing", incharge: "Karthik Balaji (SE)", tasks: [
          { name: "LT panel wiring", from: "01-02-2026", to: "20-02-2026", hrs: 12, status: "completed" },
          { name: "UPS & DB installation", from: "21-02-2026", to: "10-03-2026", hrs: 10, status: "inprogress" },
          { name: "Final continuity testing", from: "11-03-2026", to: "25-03-2026", hrs: 8, status: "pending" },
        ]
      },
    ]
  },
  { id: 10, name: "Ramesh Gopal", role: "Plumber", total: 160, occupied: 0, projects: [] },
  {
    id: 11, name: "Anita Selvam", role: "Mason", total: 160, occupied: 70, projects: [
      {
        name: "Poonamallee Bypass", dur: "6 mo", hrs: 70, status: "active", incharge: "Suresh Babu (PM)", tasks: [
          { name: "Boundary wall brick laying", from: "01-01-2026", to: "31-01-2026", hrs: 35, status: "completed" },
          { name: "Culvert masonry work", from: "01-02-2026", to: "28-02-2026", hrs: 35, status: "inprogress" },
        ]
      },
    ]
  },
  {
    id: 12, name: "Dinesh Raja", role: "Crane Operator", total: 160, occupied: 90, projects: [
      {
        name: "Sholinganallur Tower", dur: "5 mo", hrs: 50, status: "completing", incharge: "Rajesh Pandey (PM)", tasks: [
          { name: "Tower crane erection", from: "01-01-2026", to: "15-01-2026", hrs: 15, status: "completed" },
          { name: "Precast panel lifting", from: "16-01-2026", to: "28-02-2026", hrs: 20, status: "completed" },
          { name: "Crane dismantling", from: "01-03-2026", to: "15-03-2026", hrs: 15, status: "inprogress" },
        ]
      },
      {
        name: "ECR Resort", dur: "8 mo", hrs: 40, status: "planning", incharge: "Nandini Rajan (PM)", tasks: [
          { name: "Crane positioning & setup plan", from: "01-05-2026", to: "20-05-2026", hrs: 20, status: "pending" },
          { name: "Steel framework lifting", from: "21-05-2026", to: "30-06-2026", hrs: 20, status: "pending" },
        ]
      },
    ]
  },
];

// ── chips / badge components ───────────────────────────────────────────────
function StatusChip({ label, bg, color }) {
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        background: bg,
        color,
        fontWeight: 600,
      }}
    />
  );
}
function InchargePill({ name }) {
  return (
    <Chip
      size="small"
      label={name}
      color="success"
      variant="outlined"
    />
  );
}
function HrsBar({ pct }) {
  return (
    <LinearProgress
      variant="determinate"
      value={pct}
      sx={{
        height: 6,
        borderRadius: 3,
        width: 70,
      }}
    />
  );
}

// ── Confirm Dialog ─────────────────────────────────────────────────────────
function ConfirmDialog({
  open,
  title,
  sub,
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        {title}
      </DialogTitle>

      <DialogContent>
        <Typography>
          {sub}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onCancel}
        >
          Cancel
        </Button>

        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// ── Assign Modal ───────────────────────────────────────────────────────────
function AssignModal({
  open,
  emp,
  designation,
  onClose,
  onSave,
  ProjectID,
  setAssigned,
  assigned,
  EmployeeID,
  setShowAssignedGrid,
  showAssignedGrid
}) {
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const companyID = sessionStorage.getItem("companyId");
  const dispatch = useDispatch();
  const InitialValue = {
    Incharge: null,
  };

  const [incharge, setIncharge] =
    useState("");
  const [teamMembers, setTeamMembers] = useState("");

  const [hrs, setHrs] =
    useState("");

  const [remarks, setRemarks] =
    useState("");

  if (!emp) return null;

  const Fnsave = async (values) => {
    if (!values?.Incharge?.RecordID) {
      toast.error("Please select a Incharge")
      // toast.error("Please select a Project Owner")
      return;
    }
    let Actions = "Insert";
    const data = {
      InchargeID: values.Incharge.RecordID || 0,
      ProjectID: ProjectID || 0,
      EmployeeID: EmployeeID || 0,
      Action: Actions
    }
    console.log("🚀 ~ Fnsave ~ data:", data)
    const response = await dispatch(EmployeeMapController({ data }));
    if (response?.payload?.Status === "Y") {
      toast.success(response?.payload?.Msg || "Inserted successful");
      const mapResponse = await dispatch(
        EmployeeAddController({ data: { ProjectID: ProjectID } })
      );
      if (mapResponse?.payload?.Status === "Y") {
        toast.success(mapResponse?.payload?.Msg || "Employees fetched successfully");

        setAssigned(mapResponse?.payload?.Data || []);

        setShowAssignedGrid(true);
        onClose();
      }
      else {
        toast.error(mapResponse?.payload?.Msg || "Something went wrong");
      }
    } else {
      toast.error(response?.payload?.Msg || "Something went wrong");
    }
  };

  return (
    <Formik
      initialValues={InitialValue}
      // validationSchema={validationSchema}
      onSubmit={(values) => {
        Fnsave(values);
      }}
      enableReinitialize={true}
    >
      {({
        errors,
        touched,
        handleBlur,
        handleChange,
        isSubmitting,
        values,
        handleSubmit,
        setFieldValue,
      }) => (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              Add Employee To Project Teams
            </DialogTitle>

            <DialogContent>
              <Stack spacing={2} mt={1}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    bgcolor: TEAL_LIGHT,
                  }}
                >
                  <Typography
                    fontWeight={600}
                  >
                    {emp?.EmployeeName}
                  </Typography>

                  <Typography
                    variant="body2"
                  >
                    {designation?.Designation}
                  </Typography>
                </Paper>

                <Inchargecomplete
                  name="Incharge"
                  // label="Incharge"
                  label={
                    <>
                      Incharge<span style={{ color: "red", fontSize: "20px" }}> * </span>
                    </>
                  }
                  id="Incharge"
                  value={values.Incharge}
                  onChange={(newValue) => {
                    setFieldValue("Incharge", {
                      RecordID: newValue.RecordID,
                      Code: newValue.Code,
                      Name: newValue.Name,
                    });
                  }}
                  onBlur={handleBlur}
                  // url={`${listViewurl}?data={"Query":{"AccessID":"2112","ScreenName":"Team Incharge","Filter":"ProjectID='${ProjectID}'","Any":"","VerticalLicense":""}}`}
                  url={`${listViewurl}?data={"Query":{"AccessID":"2195","ScreenName":"ALLOCATIONEMP","Filter":"CompanyID='${companyID}' AND RecordID NOT IN('${EmployeeID || ""}')","Any":"","VerticalLicense":""}}`}

                />
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={onClose}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                type="submit"
                onClick={() => {
                  console.log("BUTTON CLICKED");
                  handleSubmit();
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </form>
      )}
    </Formik>
  );
}

// ── Task sub-table ─────────────────────────────────────────────────────────
function TaskTable({ tasks }) {
  if (!tasks?.length) {
    return (
      <Box sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <Typography
          color="text.secondary"
        >
          No tasks assigned
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Task</TableCell>
            <TableCell>From</TableCell>
            <TableCell>To</TableCell>
            <TableCell>Total Hrs</TableCell>
            <TableCell>Occupied Hrs</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {tasks.map((task, index) => {
            const ts =
              TASK_STATUS[task?.TaskStatus];

            return (
              <TableRow key={index}>
                <TableCell>
                  {index + 1}
                </TableCell>

                <Tooltip title={task?.TaskName}>
                  <TableCell sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {task?.TaskName}
                  </TableCell>
                </Tooltip>
                <TableCell>
                  {task?.TaskFromDate || "--"}
                </TableCell>

                <TableCell>
                  {task?.TaskToDate || "--"}
                </TableCell>

                <TableCell>
                  {task?.TaskTotalHrs}h
                </TableCell>
                <TableCell>
                  {task?.TaskOccupiedHrs}h
                </TableCell>

                <TableCell>
                  <StatusChip
                    label={ts.label}
                    bg={ts.bg}
                    color={ts.color}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// ── Project Grid ───────────────────────────────────────────────────────────
function ProjectGrid({ emp, onOpenModal, onMove, onRemove, projects }) {
  const [expandedIdx, setExpandedIdx] = useState(null);
  const [confirm, setConfirm] = useState(null);

  if (!emp) return null;

  function toggle(i) { setExpandedIdx(expandedIdx === i ? null : i); }


  return (
    <>
      <ConfirmDialog
        open={!!confirm}
        title={confirm?.title}
        sub={confirm?.sub}
        onConfirm={() => { confirm?.action(); setConfirm(null); }}
        onCancel={() => setConfirm(null)}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="subtitle1"
          // sx={{
          //   fontWeight: 600,
          //   color: TEAL_DARK,
          // }}
          >
            Allocated Projects — {emp.EmployeeName}
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onOpenModal}
          sx={{
            bgcolor: TEAL,
            "&:hover": {
              bgcolor: TEAL_DARK,
            },
          }}
        >
          Add To Project Teams
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small">

          <TableHead>
            <TableRow
              sx={{
                backgroundColor: TEAL,
                "& th": {
                  // color: "#fff",
                  fontWeight: 600,
                },
              }}
            >
              <TableCell width={60}>SL#</TableCell>
              <TableCell>Project</TableCell>
              <TableCell align="center">Hours</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Incharge</TableCell>
              <TableCell width={60}></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {projects?.map((project, index) => {

              const ps =
                PROJ_STATUS[project.ProjectStatus];

              return (
                <React.Fragment
                  key={project.RecordID || index}
                >

                  <TableRow hover>

                    <TableCell>
                      {index + 1}
                    </TableCell>

                    <TableCell>
                      <Typography
                        fontWeight={600}
                      >
                        {project.Project}
                      </Typography>
                    </TableCell>

                    <TableCell align="center">
                      {project.TotalHrs}h
                    </TableCell>

                    <TableCell align="center">
                      <StatusChip
                        label={
                          ps?.label ||
                          project.ProjectStatus
                        }
                        bg={
                          ps?.bg ||
                          "#f5f5f5"
                        }
                        color={
                          ps?.color ||
                          "#555"
                        }
                      />
                    </TableCell>

                    <TableCell align="center">
                      <Chip
                        size="small"
                        label={
                          project.ProjectIncharge
                        }
                      />
                    </TableCell>

                    <TableCell align="center">

                      <IconButton
                        onClick={() =>
                          setExpandedIdx(
                            expandedIdx === index
                              ? null
                              : index
                          )
                        }
                      >
                        <ExpandMoreIcon />
                      </IconButton>

                    </TableCell>

                  </TableRow>

                  {expandedIdx === index && (

                    <TableRow>

                      <TableCell
                        colSpan={6}
                        sx={{
                          background:
                            "#fafafa",
                        }}
                      >

                        <TaskTable
                          tasks={
                            project.Tasks
                          }
                        />

                      </TableCell>

                    </TableRow>

                  )}

                </React.Fragment>
              );
            })}

          </TableBody>

        </Table>
      </TableContainer>

    </>
  );
}

// ── Main Component ─────────────────────────────────────────────────────────
export default function ResourceAllocation() {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const state = location.state || {};
  // const [employees, setEmployees] = useState(ALL_EMP.map(e => ({ ...e, projects: e.projects.map(p => ({ ...p, tasks: [...p.tasks] })) })));
  const [assigned, setAssigned] = useState([]);
  console.log("🚀 ~ ResourceAllocation ~ assigned:", assigned)
  const [roleDropOpen, setRoleDropOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmAssigned, setConfirmAssigned] = useState(null);

  const [selectedRole, setSelectedRole] = useState(null);
  // const [selectedEmp, setSelectedEmp] = useState(null);

  const [designations, setDesignations] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState(null);

  const [employees, setEmployees] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  console.log("🚀 ~ ResourceAllocation ~ selectedEmp:", selectedEmp)
  const [pageSize, setPageSize] = useState(10);
  // const [loadingDesg, setLoadingDesg] = useState(false);

  const [employeeProjects, setEmployeeProjects] = useState([]);
  const [showAssignedGrid, setShowAssignedGrid] = useState(false);
  console.log("🚀 ~ ResourceAllocation ~ employeeProjects:", employeeProjects)
  const loadingDesg = useSelector((state) => state.formApi.DesignationGetLoading);
  const loadingEmp = useSelector((state) => state.formApi.TotalHrsOccupiedHrsGetLoading);
  const loadingProject = useSelector((state) => state.formApi.ProjectSplitupHrsListLoading);
  const teamMemberLoading = useSelector((state) => state.formApi.EmployeeAddControllerLoading);

  const companyID = sessionStorage.getItem("companyId");
  const ProjectID = params.parentID2;

  useEffect(() => {
    if (companyID && ProjectID) {
      loadDesignations();
    }
  }, [companyID, ProjectID]);
  const loadDesignations = async () => {
    try {
      const response = await dispatch(
        DesignationGet({
          data: {
            CompanyID: companyID,
            ProjectID: ProjectID,
          },
        })
      );

      console.log("Designation Response:", response);

      if (response?.payload?.Status === "Y") {
        setDesignations(response.payload.Data);
        const mapResponse = await dispatch(
          EmployeeAddController({ data: { ProjectID: ProjectID } })
        );
        if (mapResponse?.payload?.Status === "Y") {
          toast.success(mapResponse?.payload?.Msg || "Employees fetched successfully");
          setAssigned(mapResponse?.payload?.Data || []);
          setShowAssignedGrid(true);
        }
        else {
          toast.error(mapResponse?.payload?.Msg || "Something went wrong");
          setAssigned([]);
        }
      } else {
        toast.error(
          response?.payload?.Message ||
          "Failed to fetch designations."
        );
      }

    } catch (err) {
      console.error("Designation Error:", err);
    }
  };

  const loadEmployeesByDesignation = async (designation) => {

    setSelectedDesignation(designation);
    setSelectedEmp(null);

    try {

      // Actual API

      const data = {
        ProjectID: ProjectID,
        DesignationID: designation.DesignationRecordID,
      }

      const response = await dispatch(
        TotalHrsOccupiedHrsGet({ data })
      );

      console.log("Employees Response:", response);
      if (response?.payload?.Status === "Y") {
        setEmployees(response?.payload.Data || []);
        // setShowAssignedGrid(false);
        setShowAssignedGrid(true);
      }

      else {
        toast.error(
          response?.payload?.Message ||
          "No employees for the selected designation."
        );
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  const compID = sessionStorage.getItem("companyId");
  const listViewurl = useSelector(
    (state) => state.globalurl.listViewurl
  );

  // const empData = selectedRole
  //   ? employees.filter(e => e.role === selectedRole).sort((a, b) => a.occupied - b.occupied)
  //   : [];

  function pickRole(r) {
    setSelectedRole(r);
    setSelectedEmp(null);
    setRoleDropOpen(false);
  }

  // function handleEmpClick(emp) {
  //   setSelectedEmp(employees.find(e => e.id === emp.id));
  // }

  async function handleEmpClick(emp) {

    setSelectedEmp(emp);

    const data = {
      EmployeeID: emp.RecordID,
      ProjectID: ProjectID
    };

    const response = await dispatch(
      ProjectSplitupHrsList({ data })
    );

    if (response?.payload?.Status === "Y") {
      setEmployeeProjects(
        response.payload.Project || []
      );
    }
    else {
      toast.error(
        response?.payload?.Message ||
        "Failed to fetch employee projects."
      );
    }
  }
  function handleMove(projIdx, proj) {
    setEmployees(prev => prev.map(e => {
      if (e.id !== selectedEmp.RecordID) return e;
      const projects = e.projects.filter((_, i) => i !== projIdx);
      return { ...e, OccupiedHrs: Math.max(0, e.OccupiedHrs - proj.hrs), projects };
    }));
    setSelectedEmp(prev => {
      const projects = prev.projects.filter((_, i) => i !== projIdx);
      return { ...prev, OccupiedHrs: Math.max(0, prev.OccupiedHrs - proj.hrs), projects };
    });
    setModalOpen(true);
  }

  function handleRemoveFromProj(projIdx, proj) {
    setEmployees(prev => prev.map(e => {
      if (e.id !== selectedEmp.RecordID) return e;
      const projects = e.projects.filter((_, i) => i !== projIdx);
      return { ...e, OccupiedHrs: Math.max(0, e.OccupiedHrs - proj.hrs), projects };
    }));
    setSelectedEmp(prev => {
      const projects = prev.projects.filter((_, i) => i !== projIdx);
      return { ...prev, OccupiedHrs: Math.max(0, prev.OccupiedHrs - proj.hrs), projects };
    });
  }

  function handleAssign({ incharge }) {
    if (assigned.find(a => a.id === selectedEmp.RecordID)) { alert("Already added."); return; }
    // setAssigned(prev => [...prev, { ...selectedEmp, incharge }]);
    setModalOpen(false);
  }

  const handleRemoveAssigned = async (id) => {
    let Actions = "Remove";
    const data = {
      InchargeID: id.InchargeID || 0,
      ProjectID: id.ProjectID || 0,
      EmployeeID: id.EmployeeID || 0,
      Action: Actions
    }
    const response = await dispatch(EmployeeMapController({ data }));
    if (response?.payload?.Status === "Y") {
      toast.success(response?.payload?.Msg || "Inserted successful");
      const mapResponse = await dispatch(
        EmployeeAddController({ data: { ProjectID: id.ProjectID } })
      );
      if (mapResponse?.payload?.Status === "Y") {
        toast.success(mapResponse?.payload?.Msg || "Employees fetched successfully");

        setAssigned(mapResponse?.payload?.Data || []);
        setShowAssignedGrid(true);
      }
      else {
        toast.error(mapResponse?.payload?.Msg || "Something went wrong");
        setAssigned([]);
        // setShowAssignedGrid(false);
      }
    } else {
      toast.error(response?.payload?.Msg || "Something went wrong");
    }
    setConfirmAssigned(null);
  }

  function clearAll() {

    setSelectedDesignation(null);

    setEmployees([]);

    setSelectedEmp(null);

    setAssigned([]);

  }

  const InitialValues = {
    Designation: null,
    Project: state.projectName || "",
  };
  function Employee() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>

          <Typography>
            {/* List of Employees */}
            Project Teams
          </Typography>
          {/* <Typography variant="h5">{`(${rowCount})`}</Typography> */}
          <Typography sx={{ fontSize: 11, color: "#888", fontWeight: 400 }}>({assigned?.length} employee{assigned?.length > 1 ? "s" : ""})</Typography>

        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const columns = [
    {
      field: "SLNO",
      headerName: "SL#",
      width: 50,
    },
    {
      field: "EmpName",
      headerName: "Employee",
      headerAlign: "center",
      width: 250,
      // flex: 1,
    },
    {
      field: "Role",
      headerName: "Role",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "ProjectIncharge",
      headerName: "Incharge",
      headerAlign: "center",
      width: 250,
      // flex:1,
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      align:"center",
      width: 150,
      renderCell: (params) => (
        <Tooltip title="Remove">
        <Button
          size="small"
          color="error"
          // startIcon={
          //   <PersonRemoveAlt1Icon />
          // }
          onClick={() =>
            setConfirmAssigned({
              EmployeeID: params.row.EmployeeID,
              ProjectID: params.row.ProjectID,
              InchargeID: params.row.ProjectInchargeID,
              name: params.row.EmpName,
              project: params.row.ProjectName,
            })
          }
        >
          <PersonRemoveAlt1Icon />
          {/* Remove */}
        </Button>
        </Tooltip>
      )
    }
  ]
  return (

    <Box
      sx={{
        background: "#f5f5f5",
        minHeight: "100vh",
        p: {
          xs: 1,
          sm: 2,
          md: 3,
        },
      }}
    >
      {loadingDesg ? <LinearProgress /> : null}
      {loadingEmp ? <LinearProgress /> : null}
      {loadingProject ? <LinearProgress /> : null}
      {teamMemberLoading ? <LinearProgress /> : null}
      {designations?.length === 0 && !loadingDesg ? (
        <Box sx={{ padding: 4, textAlign: "center", color: "#777" }}>
          No designations found for this project.
        </Box>
      ) : null}
      {designations?.length > 0 && !loadingDesg ? (
        <>
          {/* AppBar */}
          <Paper
            elevation={1}
            sx={{
              background: TEAL,
              p: 2,
              mb: 2,
              borderRadius: 2,
              overflowX: "auto",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                // color: "#fff",
                fontWeight: 600,
                fontSize: {
                  xs: "1rem",
                  md: "1.2rem",
                },
              }}
              onClick={() => navigate("/Apps/TR133/Project")}
            >
              {/* Effort Allocation — {state.projectName || ""} */}
              Required Vs Availability — {state.projectName || ""}
            </Typography>
          </Paper>

          <Box sx={{ mb: 4 }}>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                // color: TEAL_DARK,
                // fontWeight: 600,
              }}
            >
              {/* Designations */}
              Designation Wise Efforts
            </Typography>

            <TableContainer component={Paper}>
              <Table size="small">

                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: TEAL,
                      "& th": {
                        // color: "#fff",
                        fontWeight: 600,
                      },
                    }}
                  >
                    <TableCell>SL#</TableCell>
                    <TableCell>Designation</TableCell>
                    <TableCell align="center">
                      Estimated Hours
                    </TableCell>
                    {/* <TableCell align="center">
                  Employees
                </TableCell> */}
                  </TableRow>
                </TableHead>

                <TableBody>

                  {designations?.map((row, index) => (

                    <TableRow
                      key={row.DesignationRecordID}
                      hover
                      selected={
                        selectedDesignation?.DesignationRecordID ===
                        row.DesignationRecordID
                      }
                      onClick={() =>
                        loadEmployeesByDesignation(row)
                      }
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      <TableCell>
                        {index + 1}
                      </TableCell>

                      <TableCell>

                        <Typography
                          fontWeight={600}
                          color={TEAL_DARK}
                        >
                          {row.Designation}
                        </Typography>

                      </TableCell>

                      <TableCell align="center">

                        <Chip
                          size="small"
                          label={`${row.Estimatedhrs} Hrs`}
                          color="primary"
                        />

                      </TableCell>
                      {/* <TableCell align="center">

                    <Chip
                      size="small"
                      label={`${row.EmployeeCount} Employees`}
                      color="primary"
                    />

                  </TableCell> */}

                    </TableRow>

                  ))}

                </TableBody>

              </Table>
            </TableContainer>

          </Box>

          <Box>
            {/* Employee grid */}
            {employees?.length > 0 && (
              <Box sx={{ marginBottom: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1"
                  // sx={{
                  //   fontWeight: 600,
                  //   color: TEAL_DARK,
                  // }}
                  >
                    Employees - {selectedDesignation?.Designation || ""}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 10,
                      background: TEAL_LIGHT,
                      color: TEAL_DARK,
                      padding: "2px 8px",
                      borderRadius: 10,
                      border: `1px solid ${TEAL_BORDER}`,
                      fontWeight: 700,
                    }}
                  >
                    {employees.length} Employees
                  </Typography>
                  {/* <Typography sx={{ fontSize: 11, color: "#888", fontWeight: 400 }}>(sorted by most free hours)</Typography> */}
                </Box>
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: 2,
                    overflowX: "auto",
                  }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow
                        sx={{
                          backgroundColor: TEAL,
                          "& th": {
                            // color: "#fff",
                            fontWeight: 600,
                          },
                        }}
                      >
                        <TableCell>SL#</TableCell>
                        <TableCell>Employee</TableCell>

                        <TableCell align="center">Total</TableCell>
                        <TableCell align="center">Occupied</TableCell>
                        <TableCell align="center">Free</TableCell>
                        <TableCell>Occupancy</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {employees?.map((emp, index) => {
                        // const free = emp.TotalHrs - emp.OccupiedHrs;
                        const pct =
                          Number(emp.TotalHrs) > 0
                            ? Math.round(
                              (Number(emp.OccupiedHrs) /
                                Number(emp.TotalHrs)) *
                              100
                            )
                            : 0;
                        return (
                          <TableRow
                            key={emp.RecordID}
                            hover
                            selected={selectedEmp?.RecordID === emp.RecordID}
                            onClick={() => handleEmpClick(emp)}
                            sx={{
                              cursor: "pointer",
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>

                            <TableCell>
                              <Stack spacing={0.5}>
                                <Typography
                                  fontWeight={600}
                                  color={TEAL_DARK}
                                >
                                  {emp.EmployeeName}
                                </Typography>

                                {assigned.some(
                                  (a) => a.id === emp.RecordID
                                ) && (
                                    <Chip
                                      size="small"
                                      label="Added"
                                      color="success"
                                    />
                                  )}
                              </Stack>
                            </TableCell>

                            <TableCell align="center">
                              {emp.TotalHrs}h
                            </TableCell>

                            <TableCell align="center">
                              {emp.OccupiedHrs}h
                            </TableCell>

                            <TableCell align="center">
                              {emp.FreeHrs}h
                            </TableCell>

                            <TableCell>
                              <Stack spacing={1}>
                                <Typography
                                  variant="caption"
                                >
                                  {pct}%
                                </Typography>

                                <LinearProgress
                                  variant="determinate"
                                  value={pct}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {/* Project grid */}
            {(selectedEmp && employeeProjects.length > 0) ? (
              <Box sx={{ marginBottom: 4 }}>
                <ProjectGrid
                  emp={selectedEmp}
                  projects={employeeProjects || []}
                  onOpenModal={() => setModalOpen(true)}
                  onMove={handleMove}
                  onRemove={handleRemoveFromProj}
                />
              </Box>
            ) : (
              <Box sx={{ padding: 4, textAlign: "center", color: "#777" }}>
                {selectedEmp ? "No projects allocated to this employee." : "Select a designation to view allocated employees."}
              </Box>
            )}

            {/* Assigned grid */}
            {(showAssignedGrid && assigned?.length > 0) && (
              <Box>
                {/* <Box>
                  Added to: {assigned?.ProjectName}
                  <Typography sx={{ fontSize: 11, color: "#888", fontWeight: 400 }}>({assigned?.length} employee{assigned?.length > 1 ? "s" : ""})</Typography>
                </Box> */}
                {/* <TableContainer
                  component={Paper}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow
                        sx={{
                          bgcolor: TEAL_DARK,
                        }}
                      >
                        <TableCell sx={{ color: "#fff" }}>
                          #
                        </TableCell>

                        <TableCell sx={{ color: "#fff" }}>
                          Employee
                        </TableCell>

                        <TableCell sx={{ color: "#fff" }}>
                          Role
                        </TableCell>

                        <TableCell sx={{ color: "#fff" }}>
                          Incharge
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {assigned.map((emp, index) => {

                        return (
                          <TableRow key={emp.RecordID}>
                            <TableCell>
                              {index + 1}
                            </TableCell>

                            <TableCell>
                              {emp.EmpName}
                            </TableCell>

                            <TableCell>
                              {emp.Role}
                            </TableCell>

                            <TableCell>
                              {emp.ProjectIncharge}
                            </TableCell>
                            <TableCell>
                              <Button
                                size="small"
                                color="error"
                                startIcon={
                                  <DeleteIcon />
                                }
                                onClick={() =>
                                  setConfirmAssigned({
                                    EmployeeID: emp.EmployeeID,
                                    ProjectID: emp.ProjectID,
                                    InchargeID: emp.ProjectInchargeID,
                                    name: emp.EmpName,
                                    project: emp.ProjectName,
                                  })
                                }
                              >
                                Remove
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer> */}
                <Box
                  m="5px 0 0 0"
                  height="50vh"
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#D3D3D3",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rows={assigned}
                    columns={columns}
                    loading={teamMemberLoading}
                    disableSelectionOnClick
                    getRowId={(row) => row.RecordID}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) =>
                      setPageSize(newPageSize)
                    }
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: Employee,
                    }}
                    // onStateChange={(stateParams) =>
                    //   setRowCount(stateParams.pagination.rowCount)
                    // }
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                  />
                </Box>
              </Box>)}

            {/* Modals */}
            <AssignModal ProjectID={ProjectID} open={modalOpen} emp={selectedEmp} designation={selectedDesignation} onClose={() => setModalOpen(false)} onSave={handleAssign} assigned={assigned}
              setAssigned={setAssigned} EmployeeID={selectedEmp?.RecordID} setShowAssignedGrid={setShowAssignedGrid} showAssignedGrid={showAssignedGrid} />
            <ConfirmDialog
              open={!!confirmAssigned}
              title={`Remove ${confirmAssigned?.name} from this project?`}
              sub={`This employee will be deassigned from ${confirmAssigned?.project || ""}`}
              onConfirm={() => handleRemoveAssigned(confirmAssigned)}
              onCancel={() => setConfirmAssigned(null)}
            />
          </Box>
        </>) : (false)}
    </Box>
  );
}
